 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		48: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		48: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"vendors~StoryTemplateChunkstory-templates-listicle-story~StoryTemplateChunkstory-templates-listicle-~b18f1abc","1":"vendors~StoryTemplateChunkstory-templates-listicle-story~StoryTemplateChunkstory-templates-listicle-~1c33e2aa","2":"vendors~StoryTemplateChunkstory-templates-listicle-story~StoryTemplateChunkstory-templates-listicle-~3d2d8b13","3":"vendors~StoryTemplateChunkstory-templates-listicle-story~StoryTemplateChunkstory-templates-listicle-~2bcb998f","4":"footer_1~footer_2~footer_3~header_1~header_2~header_3~header_4~single-layer-header_1~single-layer-he~2c9e60d9","5":"vendors~header_1~header_2~header_3~header_4~single-layer-header_1~single-layer-header_2~single-layer~2cb341c2","6":"StoryTemplateChunkstory-templates-listicle-story","7":"StoryTemplateChunkstory-templates-listicle-story-new","8":"StoryTemplateChunkstory-templates-listicle-story-old","9":"StoryTemplateChunkstory-templates-live-blog","10":"StoryTemplateChunkstory-templates-live-blog-new","11":"StoryTemplateChunkstory-templates-live-blog-old","12":"StoryTemplateChunkstory-templates-photo-story","13":"StoryTemplateChunkstory-templates-photo-story-new","14":"StoryTemplateChunkstory-templates-photo-story-old","15":"StoryTemplateChunkstory-templates-snapshot","16":"StoryTemplateChunkstory-templates-text-story","17":"StoryTemplateChunkstory-templates-text-story-new","18":"StoryTemplateChunkstory-templates-text-story-old","19":"StoryTemplateChunkstory-templates-video-story","20":"StoryTemplateChunkstory-templates-video-story-new","21":"StoryTemplateChunkstory-templates-video-story-old","22":"StoryTemplateChunkstory-templates-visual-story","23":"vendors~StoryTemplateChunkstory-templates-visual-story","24":"vendors~glide~home~list","25":"StoryTemplateChunkstory-templates-other","26":"StoryTemplateChunkstory-templates-paywall-story","27":"StoryTemplateChunkstory-templates-photo-story-old-story-selectors","28":"StoryTemplateChunkstory-templates-public-story","29":"StoryTemplateChunkstory-templates-story-selectors","30":"StoryTemplateChunkstory-templates-text-story-old-story-selectors","31":"StoryTemplateChunkstory-templates-video-story-old-story-selectors","32":"vendors~StoryTemplateChunkstory-templates-public-story","33":"vendors~firebase-app~firebase-messaging","34":"vendors~home~list","36":"SSOWrapperBase","37":"SidebarTemplate","38":"StoryTemplateChunkstory-templates-blank-m-css","39":"StoryTemplateChunkstory-templates-listicle-story-listicle-m-css","40":"StoryTemplateChunkstory-templates-listicle-story-old-listicle-m-css","41":"StoryTemplateChunkstory-templates-live-blog-old-live-blog-module-css","42":"StoryTemplateChunkstory-templates-photo-story-old-photo-module-css","43":"StoryTemplateChunkstory-templates-snapshot-snapshot-m-css","44":"StoryTemplateChunkstory-templates-text-story-old-text-story-m-css","45":"StoryTemplateChunkstory-templates-video-story-new-video-story-m-css","46":"StoryTemplateChunkstory-templates-video-story-old-video-m-css","47":"StoryTemplateChunkstory-templates-visual-story-visual-story-m-css","49":"firebase-app","51":"footer_1","52":"footer_2","53":"footer_3","54":"glide","55":"header_1","56":"header_2","57":"header_3","58":"header_4","59":"home","60":"list","61":"metypeFeedWidget","63":"qtc-parsecsv","64":"secret-mode","66":"single-layer-header_1","67":"single-layer-header_2","68":"single-layer-header_3","69":"single-layer-header_4","70":"single-layer-header_5","71":"story","72":"subscription","73":"vendors~firebase-messaging","74":"vendors~qtc-react-youtube","75":"vendors~secret-mode"}[chunkId]||chunkId) + "-" + "82bf1f19db0eaeb60256" + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"3":1,"4":1,"6":1,"7":1,"8":1,"9":1,"10":1,"11":1,"12":1,"13":1,"14":1,"15":1,"16":1,"17":1,"18":1,"19":1,"20":1,"21":1,"22":1,"25":1,"26":1,"28":1,"34":1,"36":1,"37":1,"38":1,"39":1,"40":1,"41":1,"42":1,"43":1,"44":1,"45":1,"46":1,"47":1,"51":1,"52":1,"53":1,"54":1,"55":1,"56":1,"57":1,"58":1,"59":1,"60":1,"64":1,"66":1,"67":1,"68":1,"69":1,"70":1,"71":1,"72":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"vendors~StoryTemplateChunkstory-templates-listicle-story~StoryTemplateChunkstory-templates-listicle-~b18f1abc","1":"vendors~StoryTemplateChunkstory-templates-listicle-story~StoryTemplateChunkstory-templates-listicle-~1c33e2aa","2":"vendors~StoryTemplateChunkstory-templates-listicle-story~StoryTemplateChunkstory-templates-listicle-~3d2d8b13","3":"vendors~StoryTemplateChunkstory-templates-listicle-story~StoryTemplateChunkstory-templates-listicle-~2bcb998f","4":"footer_1~footer_2~footer_3~header_1~header_2~header_3~header_4~single-layer-header_1~single-layer-he~2c9e60d9","5":"vendors~header_1~header_2~header_3~header_4~single-layer-header_1~single-layer-header_2~single-layer~2cb341c2","6":"StoryTemplateChunkstory-templates-listicle-story","7":"StoryTemplateChunkstory-templates-listicle-story-new","8":"StoryTemplateChunkstory-templates-listicle-story-old","9":"StoryTemplateChunkstory-templates-live-blog","10":"StoryTemplateChunkstory-templates-live-blog-new","11":"StoryTemplateChunkstory-templates-live-blog-old","12":"StoryTemplateChunkstory-templates-photo-story","13":"StoryTemplateChunkstory-templates-photo-story-new","14":"StoryTemplateChunkstory-templates-photo-story-old","15":"StoryTemplateChunkstory-templates-snapshot","16":"StoryTemplateChunkstory-templates-text-story","17":"StoryTemplateChunkstory-templates-text-story-new","18":"StoryTemplateChunkstory-templates-text-story-old","19":"StoryTemplateChunkstory-templates-video-story","20":"StoryTemplateChunkstory-templates-video-story-new","21":"StoryTemplateChunkstory-templates-video-story-old","22":"StoryTemplateChunkstory-templates-visual-story","23":"vendors~StoryTemplateChunkstory-templates-visual-story","24":"vendors~glide~home~list","25":"StoryTemplateChunkstory-templates-other","26":"StoryTemplateChunkstory-templates-paywall-story","27":"StoryTemplateChunkstory-templates-photo-story-old-story-selectors","28":"StoryTemplateChunkstory-templates-public-story","29":"StoryTemplateChunkstory-templates-story-selectors","30":"StoryTemplateChunkstory-templates-text-story-old-story-selectors","31":"StoryTemplateChunkstory-templates-video-story-old-story-selectors","32":"vendors~StoryTemplateChunkstory-templates-public-story","33":"vendors~firebase-app~firebase-messaging","34":"vendors~home~list","36":"SSOWrapperBase","37":"SidebarTemplate","38":"StoryTemplateChunkstory-templates-blank-m-css","39":"StoryTemplateChunkstory-templates-listicle-story-listicle-m-css","40":"StoryTemplateChunkstory-templates-listicle-story-old-listicle-m-css","41":"StoryTemplateChunkstory-templates-live-blog-old-live-blog-module-css","42":"StoryTemplateChunkstory-templates-photo-story-old-photo-module-css","43":"StoryTemplateChunkstory-templates-snapshot-snapshot-m-css","44":"StoryTemplateChunkstory-templates-text-story-old-text-story-m-css","45":"StoryTemplateChunkstory-templates-video-story-new-video-story-m-css","46":"StoryTemplateChunkstory-templates-video-story-old-video-m-css","47":"StoryTemplateChunkstory-templates-visual-story-visual-story-m-css","49":"firebase-app","51":"footer_1","52":"footer_2","53":"footer_3","54":"glide","55":"header_1","56":"header_2","57":"header_3","58":"header_4","59":"home","60":"list","61":"metypeFeedWidget","63":"qtc-parsecsv","64":"secret-mode","66":"single-layer-header_1","67":"single-layer-header_2","68":"single-layer-header_3","69":"single-layer-header_4","70":"single-layer-header_5","71":"story","72":"subscription","73":"vendors~firebase-messaging","74":"vendors~qtc-react-youtube","75":"vendors~secret-mode"}[chunkId]||chunkId) + "-" + {"0":"31d6cfe0d16ae931b73c","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"c3df0332bf9c534f4de5","4":"213da90d52914217d432","5":"31d6cfe0d16ae931b73c","6":"7adc3e435fc0a7ab5de5","7":"9a6f0016dee51e3813c8","8":"ece5da540d192a68e2f0","9":"49f962ed015ca997928c","10":"9a6f0016dee51e3813c8","11":"4b285c5e5b046dcb8849","12":"870f4686762628cc9a9a","13":"dc1c51cc33b00522019b","14":"ff653c5146ef0dc49bd1","15":"f80bac5ed3fa06bd17e4","16":"aee0aec84931c607c634","17":"dc1c51cc33b00522019b","18":"1372a8dfb510a6be6e30","19":"79f52009ecd7d75c5b8e","20":"5b857daecbe8b006d9b9","21":"2a5fea256a5883b971a9","22":"8fc1345e6a4c8676e91e","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"7ce2d77f242e1a01f67f","26":"e9a2218f9cfe526b7a5e","27":"31d6cfe0d16ae931b73c","28":"06f2d16d2e977adf6176","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"acf8c787e76c83154ad1","35":"31d6cfe0d16ae931b73c","36":"a751517e4328b0ad33d7","37":"3a48db6f0391e03de3a4","38":"775be5d7b6c5f5605d5f","39":"53849cc3faa0f7c41546","40":"5026be7e629e76b7e0a6","41":"afc60551b94b0a6c07dd","42":"b38bff7c081fe54aa0d0","43":"0c35b421194883ac71c1","44":"6a6ad83bd773e1e59cfd","45":"8063b69d180099ca12fe","46":"9aa9bdde99cbef6edd54","47":"1a35dbe55fc5adce6eec","49":"31d6cfe0d16ae931b73c","51":"8e2ac9f97b5b41d27941","52":"beb7efde753797a08ff7","53":"7ca80661d31bb2a8c7c2","54":"5601a62b777eb193927d","55":"a897170a26822149d1d7","56":"cc3072fac782b4cb3708","57":"c3e35fc7b382b778af01","58":"96db8a04e80e62f2fdbd","59":"3586b7d5f5bf2b35cc60","60":"c6cc2f4388881a1b69f2","61":"31d6cfe0d16ae931b73c","63":"31d6cfe0d16ae931b73c","64":"499d1826a1fbbe7088dc","66":"56a301bef26be30b92d9","67":"22fd139b0e9b63aaee86","68":"00161dd24339d68dfcb9","69":"8ef33fbaeedf3956d6f5","70":"8ae35b8ade9ce5c59bd7","71":"89dae3e9c98a64e9acde","72":"067c573f0e295f52d8da","73":"31d6cfe0d16ae931b73c","74":"31d6cfe0d16ae931b73c","75":"31d6cfe0d16ae931b73c","76":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							var error = new Error('Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')');
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}

 		// chunk preloadng for javascript

 		var chunkPreloadMap = {
 			"71": [
 				0,
 				1,
 				2,
 				3,
 				6,
 				7,
 				8,
 				9,
 				10,
 				11,
 				25,
 				26,
 				12,
 				13,
 				14,
 				16,
 				17,
 				18,
 				19,
 				20,
 				21,
 				32,
 				28,
 				23,
 				22,
 				38,
 				39,
 				40,
 				41,
 				42,
 				27,
 				29,
 				30,
 				44,
 				45,
 				31,
 				46,
 				47
 			]
 		};

 		var chunkPreloadData = chunkPreloadMap[chunkId];
 		if(chunkPreloadData) {
 			chunkPreloadData.forEach(function(chunkId) {
 				if(installedChunks[chunkId] === undefined) {
 					installedChunks[chunkId] = null;
 					var link = document.createElement('link');

 					link.charset = 'utf-8';
 					if (__webpack_require__.nc) {
 						link.setAttribute("nonce", __webpack_require__.nc);
 					}
 					link.rel = "preload";
 					link.as = "script";
 					link.href = jsonpScriptSrc(chunkId);
 					document.head.appendChild(link);
 				}
 			});
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/quintype-ace/assets/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 198);
